import { loadRuntimeEnv } from './runtime/runtime-env';

// env-config.js yuklendikten sonra uygulama import edilir; boylece config.ts runtime degerleri gorur.
loadRuntimeEnv().then(() => import('./bootstrap'));

export {};
